import styled from 'styled-components'

const PopOverBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 17px;
  margin-bottom: 20px;
  margin-left: 17px;
  width: auto;
`

export default PopOverBody
